var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadIdeaSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6317 2.0946C7.93818 2.68997 5.12379 5.77634 5.12379 9.49428V9.67437C5.12379 9.88218 5.05364 10.0844 4.92387 10.2506L2.31238 13.5962C2.10961 13.8559 2 14.1719 2 14.4966C2 15.3254 2.69928 15.9973 3.5619 15.9973H5.12379V18.4554C5.12379 19.3079 5.84312 19.9991 6.73045 19.9991C7.72816 19.9991 8.71216 19.7759 9.60454 19.3472L10.3301 18.9986V20.9995C10.3301 21.5521 10.7963 22 11.3714 22H11.6317V2.0946Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1936 21.9909C14.0068 21.916 14.7075 21.3877 14.9698 20.6318L15.5364 18.9986L17.163 18.0963L18.9184 18.4414C19.7966 18.6141 20.6913 18.2275 21.1394 17.4816L21.721 16.5138C22.1692 15.768 22.0703 14.8302 21.4756 14.1858L20.2868 12.8978L20.2867 11.0932L21.4755 9.80509C22.0702 9.1607 22.1691 8.22296 21.7209 7.47709L21.1393 6.50933C20.6912 5.76346 19.7965 5.37683 18.9183 5.54949L17.1629 5.89463L15.5364 4.99223L14.9698 3.35902C14.7075 2.60313 14.0068 2.07486 13.1936 2V21.9909Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadIdeaSetting);
export default __webpack_public_path__ + "static/media/head-idea-setting.b6b3d8ce47d2b3dfa449372485f51b09.svg";
export { ForwardRef as ReactComponent };